import { i as e, r as t } from "./errors-BJxlOkXf.js";
import { c as n, i as r, l as i, n as a, o } from "./formSessionValidation-CVWkHZ2j.js";
import { n as s, r as c } from "./formSessionGuard-CQFBevBW.js";
//#region src/shell/flowPageBridge.ts
function l(e) {
	let t, n = () => t || (t = Promise.resolve().then(e.save).then(d).finally(() => {
		t = void 0;
	}), t);
	return Object.freeze({
		save: n,
		prepareSubmit: async () => u(await n())
	});
}
function u(e) {
	let n = d(e);
	if (n.syncStatus === "PENDING") throw new t("SDK_DRAFT_SYNC_PENDING", "草稿已在业务系统保存，正在同步中台，请稍后再发起流程");
	return n;
}
function d(e) {
	let n = e?.coreDraftVersion ?? e?.expectedDraftVersion;
	if (!e || !f(e.draftPublicId) || typeof e.businessObjectPublicId != "string" || !e.businessObjectPublicId.trim() || !f(e.operationId) || !["SYNCED", "PENDING"].includes(e.syncStatus) || e.syncStatus === "SYNCED" && (!Number.isInteger(n) || (n ?? 0) < 1 || e.coreDraftVersion !== void 0 && e.expectedDraftVersion !== void 0 && e.coreDraftVersion !== e.expectedDraftVersion) || e.syncStatus === "PENDING" && (e.coreDraftVersion !== void 0 || e.expectedDraftVersion !== void 0)) throw new t("SDK_DRAFT_RESULT_INVALID", "草稿页面返回结果不符合 SDK 契约");
	return e.syncStatus === "PENDING" ? Object.freeze({
		draftPublicId: e.draftPublicId,
		businessObjectPublicId: e.businessObjectPublicId,
		operationId: e.operationId,
		syncStatus: e.syncStatus
	}) : Object.freeze({
		draftPublicId: e.draftPublicId,
		businessObjectPublicId: e.businessObjectPublicId,
		operationId: e.operationId,
		syncStatus: e.syncStatus,
		coreDraftVersion: n
	});
}
function f(e) {
	return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(e);
}
//#endregion
//#region src/shell/formSessionBridge.ts
function p(t, n) {
	let r = s(n), i = (n.initialSnapshot ?? n.getSnapshot()).context;
	if (t.contextType !== i.contextType || i.contextType === "WORK_ITEM" && i.recipientType !== "TODO" || !t.bridge || typeof t.bridge.save != "function") throw e("CAPABILITY_MISMATCH");
	if (t.contextType === "WORK_ITEM") {
		if (typeof t.bridge.validate != "function") throw e("CAPABILITY_MISMATCH");
		let i = t.bridge;
		return Object.freeze({
			contextType: "WORK_ITEM",
			bridge: Object.freeze({
				validate: (t, a) => r.run(async () => {
					let r = n.getSnapshot();
					if (r.context.contextType !== "WORK_ITEM") throw e("STALE");
					let o = await i.validate(Object.freeze({ ...t }), a);
					if (n.getSnapshot().revision !== r.revision) throw e("STALE");
					if (o.workflowTaskPublicId !== r.context.workflowTaskPublicId || o.actionCode !== t.actionCode) throw e("CAPABILITY_MISMATCH");
					return o;
				}),
				save: (t, a) => r.run(async () => {
					let r = n.getSnapshot();
					if (r.context.contextType !== "WORK_ITEM") throw e("STALE");
					let o = await i.save(Object.freeze({ ...t }), a);
					if (n.getSnapshot().revision !== r.revision) throw e("STALE");
					if (o.workflowTaskPublicId !== r.context.workflowTaskPublicId || o.operationId !== t.operationId) throw e("CAPABILITY_MISMATCH");
					return o;
				})
			})
		});
	}
	if (typeof t.bridge.prepareSubmit != "function") throw e("CAPABILITY_MISMATCH");
	let a = t.bridge, o = (t) => r.run(async () => {
		let r = n.getSnapshot();
		if (r.context.contextType !== "DRAFT") throw e("STALE");
		let i = await l({ save: () => a[t]() }).save();
		if (n.getSnapshot().revision !== r.revision) throw e("STALE");
		if (i.draftPublicId !== r.context.draftContext.draftPublicId || i.businessObjectPublicId !== r.context.businessObjectPublicId) throw e("CAPABILITY_MISMATCH");
		return t === "prepareSubmit" ? u(i) : i;
	});
	return Object.freeze({
		contextType: "DRAFT",
		bridge: Object.freeze({
			save: () => o("save"),
			prepareSubmit: () => o("prepareSubmit")
		})
	});
}
//#endregion
//#region src/shell/formSessionClient.ts
function m(t, s) {
	let l = o(t.formSessionHost);
	if (t.runtimePurpose !== "form-session" || typeof s.applyView != "function") throw e("CAPABILITY_INVALID");
	let u = Object.freeze({ status: "idle" }), d, f = !1, m = !1, h = 0, g, _, v, y, b = /* @__PURE__ */ new Set(), x = (e) => {
		u = Object.freeze(e), b.forEach((e) => e());
	}, S = (e) => !f && d === e && !e.abort.signal.aborted, C = (t) => {
		if (!S(t)) throw e("STALE");
	}, w = (t) => {
		if (i(t), !d || !r(d.snapshot.token, t) || !S(d)) throw e("STALE");
		if (!d.committed || d.pendingUpdates > 0 || d.updating) throw e("NOT_READY");
		return d.committed;
	}, T = (e) => {
		e.abort.abort(), e.removeAbort(), e.bridge?.dispose(), e.bridge = void 0;
	}, E = (e, t) => (e && T(e), c(async (e) => {
		await s.applyView(null, e);
	}, {
		signal: t.signal,
		remainingMs: Math.min(2e3, t.remainingMs)
	}, "CLOSE_TIMEOUT").catch((e) => {
		throw m = !0, e;
	})), D = (n, r) => {
		let i = Object.getOwnPropertyDescriptors(t);
		for (let e of [
			"operationHost",
			"workflowPageHost",
			"processInitiationViewHost",
			"draftPageContext",
			"formSessionScope"
		]) delete i[e];
		let a = (e, t) => {
			i[e] = {
				value: t,
				enumerable: !0
			};
		};
		a("formSessionScope", r);
		let o = n.snapshot;
		if (o.context.contextType === "WORK_ITEM") {
			let t;
			a("workflowPageHost", Object.freeze({
				pageRoute: o.pageRoute,
				context: o.context,
				reportReady: (e) => {
					r.reportReady({
						...e,
						contextType: "WORK_ITEM"
					});
				},
				reportFailed: r.reportFailed,
				registerBridge: (i) => {
					if (C(n), i) {
						if (t) throw e("BRIDGE_DUPLICATE");
						t = r.registerPageBridge({
							contextType: "WORK_ITEM",
							bridge: i
						});
					} else t?.(), t = void 0;
				}
			}));
		} else if (o.context.contextType === "DRAFT") {
			let t;
			i.draftPageContext = {
				get: () => w(o.token).context,
				enumerable: !0
			}, a("operationHost", Object.freeze({
				pageRoute: o.pageRoute,
				reportRouteReady: (e) => {
					r.reportReady({
						contextType: "DRAFT",
						pageRoute: e,
						saveCapability: "REQUIRED"
					});
				},
				reportRouteFailed: (e) => {
					r.reportFailed({
						...e,
						retryable: !1
					});
				},
				registerBridge: (i) => {
					if (C(n), i) {
						if (t) throw e("BRIDGE_DUPLICATE");
						t = r.registerPageBridge({
							contextType: "DRAFT",
							bridge: i
						});
					} else t?.(), t = void 0;
				}
			}));
		} else a("processInitiationViewHost", Object.freeze({
			pageRoute: o.pageRoute,
			context: o.context,
			reportReady: (e) => {
				r.reportReady({
					...e,
					contextType: "PROCESS_INITIATION_VIEW",
					saveCapability: "NONE"
				});
			},
			reportFailed: r.reportFailed
		}));
		return Object.freeze(Object.defineProperties({}, i));
	}, O = Object.freeze({
		protocolVersion: 1,
		activate(a, o, _) {
			if (f) return Promise.reject(e("STALE"));
			let y = n(a, t, l.runtimeEpoch);
			if (!r(y.token, i(o.token)) || !o.signal || typeof o.signal.aborted != "boolean" || typeof o.signal.addEventListener != "function" || typeof o.signal.removeEventListener != "function" || [
				"registerPageBridge",
				"reportReady",
				"reportFailed",
				"reportState"
			].some((e) => typeof o[e] != "function")) throw e("CAPABILITY_INVALID");
			if (g && r(g.snapshot.token, y.token)) {
				if (JSON.stringify(g.snapshot) !== JSON.stringify(y)) throw e("INPUT_INVALID");
				return g.result;
			}
			if (y.token.generation <= h) return Promise.resolve({
				token: y.token,
				status: "SUPERSEDED"
			});
			if (h = y.token.generation, o.signal.aborted || _.signal.aborted) return Promise.resolve({
				token: y.token,
				status: "ABORTED"
			});
			if (m || v) return Promise.reject(e("CLOSE_TIMEOUT"));
			let b = d;
			b && T(b);
			let O = new AbortController(), k = AbortSignal.any([O.signal, o.signal]), A = {
				snapshot: y,
				abort: O,
				ready: !1,
				updating: !1,
				pendingUpdates: 0,
				updates: /* @__PURE__ */ new Map(),
				updateTail: Promise.resolve(),
				removeAbort: () => void 0
			};
			d = A;
			let j = () => {
				O.abort(), d === A && (A.committed = void 0, x({ status: "idle" }));
			};
			o.signal.addEventListener("abort", j, { once: !0 }), A.removeAbort = () => o.signal.removeEventListener("abort", j);
			let M = Object.freeze({
				token: y.token,
				signal: k,
				registerPageBridge: (t) => {
					if (C(A), A.bridge) throw e("BRIDGE_DUPLICATE");
					let n = {}, r = p(t, {
						signal: k,
						isCurrent: () => S(A) && A.bridge?.id === n,
						isReady: () => A.ready && !!A.committed && A.pendingUpdates === 0 && !A.updating,
						initialSnapshot: y,
						getSnapshot: () => w(y.token)
					}), i = o.registerPageBridge(r), a = () => {
						A.bridge?.id === n && (A.bridge = void 0, i());
					};
					return A.bridge = {
						id: n,
						dispose: a
					}, a;
				},
				reportReady: (e) => {
					if (!S(A)) return "IGNORED_STALE";
					let t = o.reportReady(e);
					return t === "ACCEPTED" && (A.ready = !0), t;
				},
				reportFailed: (t) => {
					if (!S(A)) return "IGNORED_STALE";
					let n = o.reportFailed(t);
					return n === "ACCEPTED" && (A.ready = !1, x({
						status: "failed",
						token: y.token,
						error: e("APPLY_FAILED")
					})), n;
				},
				reportState: (e) => S(A) ? o.reportState(e) : "IGNORED_STALE"
			});
			A.view = Object.freeze({
				snapshot: y,
				scope: M,
				pageRuntimeContext: D(A, M)
			}), x({
				status: "applying",
				view: A.view
			});
			let N = Date.now() + _.remainingMs, P = (async () => {
				try {
					return b && await E(b, _), C(A), await c((e) => s.applyView(A.view, e), {
						signal: AbortSignal.any([_.signal, k]),
						remainingMs: N - Date.now()
					}, "OPEN_TIMEOUT"), C(A), A.committed = y, u.status !== "failed" && x({
						status: "active",
						view: A.view
					}), Object.freeze({
						token: y.token,
						status: "APPLIED"
					});
				} catch (e) {
					if (!S(A) || _.signal.aborted) return Object.freeze({
						token: y.token,
						status: "ABORTED"
					});
					throw A.ready = !1, x({
						status: "failed",
						token: y.token,
						error: e
					}), e;
				}
			})();
			return P.catch(() => void 0), g = {
				snapshot: y,
				result: P
			}, P;
		},
		deactivate(e, t, n) {
			if (i(e), v && r(v.token, e)) return v.result;
			if (!d || !r(d.snapshot.token, e)) return Promise.resolve({
				token: e,
				status: _ && r(_, e) ? "ALREADY_RELEASED" : "STALE"
			});
			let a = d;
			T(a), d = void 0, x({ status: "idle" });
			let o = E(a, n).then(() => (_ = e, Object.freeze({
				token: e,
				status: "RELEASED"
			}))).finally(() => {
				v?.result === o && (v = void 0);
			});
			return o.catch(() => void 0), v = {
				token: e,
				result: o
			}, o;
		},
		update(t, n) {
			t = a(t);
			let o = i(t.token), l = d;
			if (!l || !S(l) || !r(l.snapshot.token, o)) return Promise.resolve({
				token: o,
				revision: t.revision,
				status: "STALE"
			});
			let u = l.committed;
			if (!u || !l.ready || u.context.contextType !== "DRAFT" || !Number.isSafeInteger(t.revision) || t.revision < 1 || !Number.isSafeInteger(t.expectedDraftVersion) || t.expectedDraftVersion < u.context.draftContext.expectedDraftVersion || Object.keys(t).some((e) => ![
				"token",
				"revision",
				"expectedDraftVersion"
			].includes(e))) throw e("UPDATE_INVALID");
			let f = l.updates.get(t.revision);
			if (f) {
				if (f.version !== t.expectedDraftVersion) throw e("UPDATE_INVALID");
				return f.result;
			}
			if (t.revision <= u.revision) return Promise.resolve({
				token: o,
				revision: t.revision,
				status: "IGNORED_OLD_REVISION"
			});
			let p = Date.now() + Math.min(2e3, n.remainingMs);
			l.pendingUpdates += 1;
			let m = l.updateTail.catch(() => void 0).then(async () => {
				C(l);
				let r = l.committed;
				if (r.context.contextType !== "DRAFT" || t.expectedDraftVersion < r.context.draftContext.expectedDraftVersion) throw e("UPDATE_INVALID");
				if (t.revision <= r.revision) return {
					token: o,
					revision: t.revision,
					status: "IGNORED_OLD_REVISION"
				};
				l.updating = !0;
				let i = a({
					...r,
					revision: t.revision,
					context: {
						...r.context,
						draftContext: {
							...r.context.draftContext,
							expectedDraftVersion: t.expectedDraftVersion
						}
					}
				}), u = Object.freeze({
					...l.view,
					snapshot: i
				});
				x({
					status: "applying",
					view: u
				});
				try {
					return await c((e) => s.applyView(u, e), {
						signal: AbortSignal.any([n.signal, l.view.scope.signal]),
						remainingMs: p - Date.now()
					}, "UPDATE_TIMEOUT"), C(l), l.committed = i, l.snapshot = i, l.view = u, l.updating = !1, {
						token: o,
						revision: t.revision,
						status: "APPLIED"
					};
				} catch (e) {
					throw l.ready = !1, S(l) && x({
						status: "failed",
						token: o,
						error: e
					}), e;
				}
			}).finally(() => {
				--l.pendingUpdates, S(l) && l.ready && l.pendingUpdates === 0 && !l.updating && x({
					status: "active",
					view: l.view
				});
			});
			return m.catch(() => void 0), l.updates.set(t.revision, {
				version: t.expectedDraftVersion,
				result: m
			}), l.updateTail = m, m;
		}
	}), k = l.registerReceiver(O);
	return Object.freeze({
		getSnapshot: () => u,
		getSessionSnapshot: w,
		subscribe(t) {
			if (f) throw e("STALE");
			return b.add(t), () => {
				b.delete(t);
			};
		},
		dispose() {
			if (y) return y;
			f = !0;
			let e = d;
			e && T(e), d = void 0, k(), b.clear();
			let t = new AbortController();
			return y = E(e, {
				signal: t.signal,
				remainingMs: 2e3
			}).then(() => {
				u = Object.freeze({ status: "idle" });
			}), y.catch(() => void 0), y;
		}
	});
}
//#endregion
export { u as i, p as n, l as r, m as t };
